/**
 * Desktop - Search molecule
 */

// Imports
import {
  init as initialInit,
  getSearchField,
  getSearchFieldPlaceholder,
  getSearchButton,
  goSearchpage,
} from '../../common/molecule/search';
import {
  isEmpty,
} from '../../common/Utils';
import {
  logError,
} from '../../common/Log';
import KeyCodes from '../../common/KeyCodes';
import GlobalVars from '../../common/GlobalVars';
import AjaxURL from '../../common/AjaxURL';
import * as events from '../../common/Events';
import {
  isMini as isHeaderMini,
} from '../organism/header';

// Constants (ids)
const searchAreaId = 'searchArea';
const searchResultsAreaId = 'searchResultsArea';
const searchResultsListId = 'searchResultsList';
const searchResultsButtonId = 'btnSearchResults';

// Constants (classes)
const filledClass = 'filled';
const slideOpenClass = 'slide-open';

/**
 * Reference to the search area element.
 * @type {Object}
 */
let searchArea = {};

/**
 * Reference to the search field element.
 * @type {Object}
 */
let searchField = {};

/**
 * Placeholder for the search field element.
 * @type {Object}
 */
let searchFieldPlaceholder = '';

/**
 * Reference to the search button element.
 * @type {Object}
 */
let searchButton = {};

/**
 * Reference to the search results area element.
 * @type {Object}
 */
let searchResultsArea = {};

/**
 * Reference to the search results button element.
 * @type {Object}
 */
let searchResultsButton = {};

/**
 * Reference to the search results list element.
 * @type {Object}
 */
let searchResultsList = {};

/**
 * Timeout to secure the search requests.
 * @type {Integer}
 */
let searchTimeout = 0;

/**
 * Object containing the Request data and functions.
 * @type {Object}
 */
let searchRequest = null;

/**
 * Whether or not the user just came back on page.
 * @type {Bool}
 */
let backOnPage = false;

function saveReferences() {
  // Save reference to the search area element
  searchArea = $(`#${searchAreaId}`);

  // Save reference to the search field element
  searchField = getSearchField();

  // Save the placeholder of the earch field element
  searchFieldPlaceholder = getSearchFieldPlaceholder();

  // Save reference to the search button element
  searchButton = getSearchButton();

  // Save reference to the search results area element
  searchResultsArea = $(`#${searchResultsAreaId}`);

  // Save reference to the search results list element
  searchResultsList = $(`#${searchResultsListId}`);

  // Save reference to the search results button element
  searchResultsButton = $(`#${searchResultsButtonId}`);
}

function searchPress(aoEvent, asDefaultValue, c, l) {
  if (aoEvent.keyCode === KeyCodes.enter) {
    aoEvent.preventDefault();
    aoEvent.stopPropagation();
    goSearchpage(asDefaultValue, c, l);
    return false;
  }
  return true;
}

function getSearchResultItemHTML(aoData) {
  return `<li class="m-list__item m-search-results__item">
    <div class="m-search-result-thumbnail">
      <div class="m-search-result-thumbnail__wrapper">
        <div class="m-search-result-thumbnail__thumbnail">
          <img class="a-img m-search-result-thumbnail__image" alt="" src="${aoData.image}" />
        </div>
        <div class="m-search-result-thumbnail__content">
          <h3 class="a-text m-search-result-thumbnail__text">
            <a class="a-link m-search-result-thumbnail__link" href="${aoData.url}">
              ${aoData.title}
            </a>
          </h3>
        </div>
      </div>
    </div>
  </li>`;
}

function handleSearchInput(asValue) {
  searchRequest = $.ajax({
    url: AjaxURL.search,
    data: {
      c: GlobalVars.C,
      l: GlobalVars.L,
      task: 'searchresult',
      query: asValue,
    },
    dataType: 'json',
    type: 'post',
  });

  searchRequest
    .done((aoResult) => {
      if (!aoResult.success) {
        logError(`Search short urls request fail : ${aoResult.error}`);
      } else if (!aoResult.data || (aoResult.data.length === 0)) {
        // No results

        searchResultsArea
          .fadeOut('fast');

        searchResultsList
          .empty();
      } else {
        // Handle the results

        const stringBuilder = [];
        const skus = [];

        aoResult.data.forEach((aoResultItem) => {
          const resultItem = aoResultItem;

          // resultItem.description = ellipsis(
          //   $(`<div>${resultItem.description}</div>`).text(),
          //   80,
          //   '...'
          // );
          resultItem.url += `?search=${asValue}`;

          stringBuilder.push(getSearchResultItemHTML(resultItem));

          skus.push(resultItem.sku);
        });

        // TODO: Use real addToDataLayer function
        // OCMS.addToDataLayer({
        //   'event': 'internalSearchAllPages',
        //   'category': 'Internal_search',
        //   'action': 'Autocompletion',
        //   'query': asValue,
        //   'searchedProducts': skus
        // });

        // Add the results to the DOM
        searchResultsList
          .empty()
          .append(stringBuilder.join(''));

        // Show the results
        searchResultsArea.fadeIn('fast');
      }
    })
    .fail((xhr, status, message) => {
      if (message !== 'abort') {
        logError(`Search short urls request fail : ${message}`);
      }
    });
}

function updateFilledStatus() {
  if (!searchField.length) {
    return;
  }

  if (searchField.val() === '') {
    searchArea.removeClass(filledClass);
  } else {
    searchArea.addClass(filledClass);
  }
}

function setEventHandlers() {
  if (!searchField.length) {
    return;
  }

  events.registerCallback({
    target: searchField,
    events: 'blur',
    handler: function onSearchFieldBlur() {
      $(this).parent().removeClass('focused');
      searchResultsArea.fadeOut('fast');
    },
  });

  events.registerCallback({
    target: searchField,
    events: 'focus',
    handler: function onSearchFieldFocus() {
      $(this).parent().addClass('focused');

      // Empty the search field on focus, except back on page
      if (!backOnPage) {
        $(this).val('');

        // Set the input as not 'filled'
        updateFilledStatus();
      }
    },
  });

  events.registerCallback({
    target: window,
    events: 'focus',
    handler: function onWindowFocus() {
      // Back on page status : enable for 500ms

      backOnPage = true;

      setTimeout(() => {
        backOnPage = false;
      }, 500);
    },
  });

  events.registerCallback({
    target: searchField,
    events: 'keyup',
    handler: function onSearchFieldKeyup(aoEvent) {
      const inputValue = $(this).val();

      clearTimeout(searchTimeout);

      if (aoEvent.keyCode === KeyCodes.enter) {
        aoEvent.preventDefault();
        aoEvent.stopPropagation();
        return false;
      }

      // Update the 'filled' status of the input
      updateFilledStatus();

      if ((searchRequest != null) && (typeof (searchRequest.abort) === 'function')) {
        searchRequest.abort();
      }

      if (isEmpty(inputValue) || (inputValue.length <= 1)) {
        // Invalid search input

        searchResultsArea
          .fadeOut('fast');

        searchResultsList
          .empty();
      } else if ((aoEvent.keyCode !== KeyCodes.space) && (aoEvent.keyCode !== KeyCodes.ampersand)) {
        // Valid search input

        searchTimeout = setTimeout(() => {
          handleSearchInput(inputValue);
        }, 150);
      }

      return true;
    },
  });

  events.registerCallback({
    target: searchField,
    events: 'keypress',
    handler: function onSearchFieldKeypress(aoEvent) {
      return searchPress(aoEvent, searchFieldPlaceholder, GlobalVars.C, GlobalVars.L);
    },
  });

  events.registerCallback({
    target: searchButton,
    events: 'click',
    handler: function onSearchButtonClick() {
      if (!isHeaderMini) {
        goSearchpage(searchFieldPlaceholder, GlobalVars.C, GlobalVars.L);
      }

      if (!searchArea.hasClass(slideOpenClass)) {
        searchArea
          .addClass(slideOpenClass);
        setTimeout(() => {
          searchField.focus();
        }, 500);
      }
      goSearchpage(searchFieldPlaceholder, GlobalVars.C, GlobalVars.L);
    },
  });

  events.registerCallback({
    target: searchResultsButton,
    events: 'click',
    handler: function onSearchResultsButtonClick() {
      goSearchpage(searchFieldPlaceholder, GlobalVars.C, GlobalVars.L);
    },
  });
}

function init() {
  $(() => {
    initialInit();

    // Save references to DOM elements
    saveReferences();

    // Set event handlers
    setEventHandlers();
  });
}

// Named exports - Functions
export {
  init,
  goSearchpage,
  searchPress,
  filledClass,
};



// WEBPACK FOOTER //
// ./js/desktop/molecule/search.js